import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Organization } from '../user-info-config/user-info-config.service';


@Injectable({
  providedIn: 'root',
})
export class OrgStateService {
  private currentOrgSubject = new BehaviorSubject<Organization | null>(null);
  currentOrg$ = this.currentOrgSubject.asObservable();

  constructor() {
    const storedOrg = localStorage.getItem('currentOrg');
    if (storedOrg) {
      this.currentOrgSubject.next(JSON.parse(storedOrg));
    }
  }

  setCurrentOrg(organization: Organization) {
    localStorage.setItem('currentOrg', JSON.stringify(organization));
    this.currentOrgSubject.next(organization);
  }

  getCurrentOrg(): Organization | null {
    return this.currentOrgSubject.getValue();
  }

  clearCurrentOrg() {
    localStorage.removeItem('currentOrg');
    this.currentOrgSubject.next(null);
  }
}
